import { useState, useRef } from "react";
import { GOLD, BLUE } from "../constants/temas";

const API = "https://adorateam-api-532602191494.us-central1.run.app";

function getToken() { return localStorage.getItem("adorateam_token"); }

async function apiReq(method, path, body) {
    const r = await fetch(`${API}${path}`, {
        method,
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
        body: body ? JSON.stringify(body) : undefined,
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.erro || "Erro");
    return data;
}

const INSTRUMENTOS = [
    "Violão", "Guitarra", "Baixo", "Bateria", "Teclado",
    "Piano", "Violino", "Saxofone", "Trompete", "Flauta",
    "Voz (Soprano)", "Voz (Contralto)", "Voz (Tenor)", "Voz (Barítono)", "Percussão",
];

export default function Perfil({ usuario, onAtualizar, tema: T }) {
    const [editando, setEditando] = useState(false);
    const [salvando, setSalvando] = useState(false);
    const [mensagem, setMensagem] = useState("");
    const [fotoPreview, setFotoPreview] = useState(null);
    const fileRef = useRef();

    const [form, setForm] = useState({
        nome: usuario?.nome || "",
        email: usuario?.email || "",
        telefone: usuario?.telefone || "",
        instrumentos: usuario?.instrumentos || [],
        instagram: usuario?.instagram || "",
        youtube: usuario?.youtube || "",
    });

    const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

    const toggleInstrumento = (inst) => {
        setForm(p => ({
            ...p,
            instrumentos: p.instrumentos.includes(inst)
                ? p.instrumentos.filter(i => i !== inst)
                : [...p.instrumentos, inst]
        }));
    };

    const selecionarFoto = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (ev) => setFotoPreview(ev.target.result);
        reader.readAsDataURL(file);
    };

    const salvar = async () => {
        setSalvando(true);
        try {
            const res = await apiReq("PUT", "/api/auth/perfil", {
                nome: form.nome,
                telefone: form.telefone,
                instrumentos: form.instrumentos,
                instagram: form.instagram,
                youtube: form.youtube,
                foto: fotoPreview || undefined,
            });
            onAtualizar({ ...usuario, ...res.usuario, foto: fotoPreview || usuario?.foto });
            setEditando(false);
            mostrarMsg("Perfil atualizado! ✓");
        } catch (e) {
            mostrarMsg("Erro: " + e.message);
        } finally {
            setSalvando(false);
        }
    };

    const mostrarMsg = (msg) => {
        setMensagem(msg);
        setTimeout(() => setMensagem(""), 3000);
    };

    const fotoCurrent = fotoPreview || usuario?.foto;
    const iniciais = (usuario?.nome || "?").split(" ").map(n => n[0]).slice(0, 2).join("").toUpperCase();

    return (
        <div style={{ padding: "16px 16px 100px", maxWidth: 430 }}>
            <style>{`@keyframes fadeUp{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}} @keyframes slideIn{from{opacity:0;transform:translateY(-8px)}to{opacity:1;transform:translateY(0)}}`}</style>

            {/* Toast */}
            {mensagem && (
                <div style={{
                    animation: "slideIn 0.3s ease",
                    position: "fixed", top: 70, left: "50%", transform: "translateX(-50%)",
                    background: "#162040", border: `1px solid ${GOLD}44`,
                    borderRadius: 12, padding: "10px 20px",
                    color: GOLD, fontSize: 13, fontWeight: 700, zIndex: 99,
                    boxShadow: "0 4px 20px #0008"
                }}>{mensagem}</div>
            )}

            {/* Header do perfil */}
            <div style={{ animation: "fadeUp 0.4s ease both", textAlign: "center", marginBottom: 24, paddingTop: 8 }}>
                {/* Avatar */}
                <div style={{ position: "relative", display: "inline-block", marginBottom: 16 }}>
                    <div style={{
                        width: 96, height: 96, borderRadius: "50%",
                        background: fotoCurrent ? "transparent" : `linear-gradient(135deg, ${GOLD}, #FFD166)`,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: 32, fontWeight: 800, color: BLUE,
                        border: `3px solid ${GOLD}44`, overflow: "hidden",
                        boxShadow: `0 4px 24px ${GOLD}33`
                    }}>
                        {fotoCurrent
                            ? <img src={fotoCurrent} alt="Foto" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                            : iniciais}
                    </div>
                    {editando && (
                        <>
                            <button onClick={() => fileRef.current?.click()} style={{
                                position: "absolute", bottom: 0, right: 0,
                                width: 30, height: 30, borderRadius: "50%",
                                background: GOLD, border: "2px solid #0f1729",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                fontSize: 14, cursor: "pointer"
                            }}>📷</button>
                            <input ref={fileRef} type="file" accept="image/*" style={{ display: "none" }} onChange={selecionarFoto} />
                        </>
                    )}
                </div>

                <div style={{ fontSize: 22, fontWeight: 800, color: T.texto }}>{usuario?.nome}</div>
                <div style={{ fontSize: 13, color: T.textoSecundario, marginTop: 2 }}>{usuario?.email}</div>

                {/* Badge role */}
                <div style={{ display: "inline-flex", alignItems: "center", gap: 6, marginTop: 8 }}>
                    <div style={{
                        background: usuario?.role === "lider" ? `${GOLD}20` : "#4caf5018",
                        border: `1px solid ${usuario?.role === "lider" ? GOLD + "44" : "#4caf5044"}`,
                        borderRadius: 20, padding: "4px 12px",
                        fontSize: 12, fontWeight: 700,
                        color: usuario?.role === "lider" ? GOLD : "#4caf50"
                    }}>
                        {usuario?.role === "lider" ? "👑 Líder" : "🎵 Membro"}
                    </div>
                    {usuario?.grupo?.nome && (
                        <div style={{
                            background: "#ffffff08", border: "1px solid #2a3a5e",
                            borderRadius: 20, padding: "4px 12px",
                            fontSize: 12, color: T.textoSecundario
                        }}>⛪ {usuario.grupo.nome}</div>
                    )}
                </div>
            </div>

            {/* Botão editar */}
            {!editando && (
                <button onClick={() => setEditando(true)} style={{
                    animation: "fadeUp 0.4s 0.05s ease both",
                    width: "100%", padding: 14, borderRadius: 14, marginBottom: 20,
                    background: `${GOLD}15`, border: `1.5px solid ${GOLD}44`,
                    color: GOLD, fontWeight: 700, fontSize: 15, cursor: "pointer"
                }}>✏️ Editar perfil</button>
            )}

            {/* ── MODO VISUALIZAÇÃO ── */}
            {!editando && (
                <div style={{ animation: "fadeUp 0.4s 0.1s ease both", display: "flex", flexDirection: "column", gap: 12 }}>
                    <InfoCard titulo="Contato" T={T}>
                        <InfoRow label="📱 Telefone" valor={usuario?.telefone || "—"} T={T} />
                        <InfoRow label="✉️ E-mail" valor={usuario?.email || "—"} T={T} />
                    </InfoCard>

                    <InfoCard titulo="Instrumentos" T={T}>
                        {(usuario?.instrumentos?.length > 0) ? (
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, paddingTop: 4 }}>
                                {usuario.instrumentos.map(inst => (
                                    <div key={inst} style={{
                                        background: `${GOLD}15`, border: `1px solid ${GOLD}33`,
                                        borderRadius: 20, padding: "5px 14px",
                                        fontSize: 13, color: GOLD, fontWeight: 600
                                    }}>{inst}</div>
                                ))}
                            </div>
                        ) : (
                            <div style={{ fontSize: 13, color: T.textoSecundario }}>Nenhum instrumento cadastrado</div>
                        )}
                    </InfoCard>

                    <InfoCard titulo="Redes sociais" T={T}>
                        <InfoRow label="📸 Instagram" valor={usuario?.instagram ? `@${usuario.instagram}` : "—"} T={T} />
                        <InfoRow label="▶️ YouTube" valor={usuario?.youtube || "—"} T={T} />
                    </InfoCard>

                    {usuario?.grupo && (
                        <InfoCard titulo="Grupo" T={T}>
                            <InfoRow label="⛪ Ministério" valor={usuario.grupo.nome || "—"} T={T} />
                            <InfoRow label="🏛 Igreja" valor={usuario.grupo.igreja || "—"} T={T} />
                            <InfoRow label="⚡ Plano" valor={usuario.grupo.plano || "—"} T={T} />
                        </InfoCard>
                    )}
                </div>
            )}

            {/* ── MODO EDIÇÃO ── */}
            {editando && (
                <div style={{ animation: "fadeUp 0.3s ease both", display: "flex", flexDirection: "column", gap: 16 }}>
                    <EditCard titulo="Dados pessoais" T={T}>
                        <Campo label="Nome completo" value={form.nome} onChange={v => set("nome", v)} T={T} />
                        <Campo label="Telefone / WhatsApp" value={form.telefone} onChange={v => set("telefone", v)} placeholder="(47) 99999-9999" T={T} />
                    </EditCard>

                    <EditCard titulo="Instrumentos que toca" T={T}>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                            {INSTRUMENTOS.map(inst => {
                                const sel = form.instrumentos.includes(inst);
                                return (
                                    <button key={inst} onClick={() => toggleInstrumento(inst)} style={{
                                        padding: "6px 14px", borderRadius: 20,
                                        border: `1.5px solid ${sel ? GOLD : "#2a3a5e"}`,
                                        background: sel ? `${GOLD}18` : "transparent",
                                        color: sel ? GOLD : T.textoSecundario,
                                        fontSize: 12, fontWeight: sel ? 700 : 400,
                                        cursor: "pointer", transition: "all 0.15s"
                                    }}>{inst}</button>
                                );
                            })}
                        </div>
                    </EditCard>

                    <EditCard titulo="Redes sociais" T={T}>
                        <Campo label="Instagram (sem @)" value={form.instagram} onChange={v => set("instagram", v)} placeholder="seuusuario" T={T} />
                        <Campo label="YouTube (canal ou link)" value={form.youtube} onChange={v => set("youtube", v)} placeholder="@seucanal" T={T} />
                    </EditCard>

                    {/* Botões */}
                    <div style={{ display: "flex", gap: 10 }}>
                        <button onClick={() => { setEditando(false); setFotoPreview(null); }} style={{
                            flex: 1, padding: 14, borderRadius: 14,
                            background: "none", border: `1.5px solid ${T.borda}`,
                            color: T.textoSecundario, fontWeight: 600, fontSize: 14, cursor: "pointer"
                        }}>Cancelar</button>
                        <button onClick={salvar} disabled={salvando} style={{
                            flex: 2, padding: 14, borderRadius: 14,
                            background: salvando ? "#2a3a5e" : `linear-gradient(135deg, ${GOLD}, #FFD166)`,
                            border: "none", color: BLUE, fontWeight: 800,
                            fontSize: 15, cursor: salvando ? "default" : "pointer",
                            boxShadow: salvando ? "none" : `0 4px 20px ${GOLD}44`
                        }}>{salvando ? "Salvando..." : "Salvar perfil ✓"}</button>
                    </div>
                </div>
            )}
        </div>
    );
}

// ── Subcomponentes ──
function InfoCard({ titulo, children, T }) {
    return (
        <div style={{ background: T.bgCard, borderRadius: 16, padding: "16px 18px", border: `1px solid ${T.borda}` }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: T.textoSecundario, letterSpacing: 0.8, marginBottom: 12 }}>{titulo.toUpperCase()}</div>
            {children}
        </div>
    );
}

function InfoRow({ label, valor, T }) {
    return (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: 10, marginBottom: 10, borderBottom: `1px solid ${T.borda}`, lastChild: { border: "none" } }}>
            <span style={{ fontSize: 13, color: T.textoSecundario }}>{label}</span>
            <span style={{ fontSize: 13, color: T.texto, fontWeight: 600, maxWidth: "60%", textAlign: "right" }}>{valor}</span>
        </div>
    );
}

function EditCard({ titulo, children, T }) {
    return (
        <div style={{ background: T.bgCard, borderRadius: 16, padding: "16px 18px", border: `1px solid ${T.borda}` }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: T.textoSecundario, letterSpacing: 0.8, marginBottom: 14 }}>{titulo.toUpperCase()}</div>
            {children}
        </div>
    );
}

function Campo({ label, value, onChange, placeholder = "", type = "text", T }) {
    return (
        <div style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: T.textoSecundario, marginBottom: 6 }}>{label.toUpperCase()}</div>
            <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder}
                   style={{
                       width: "100%", padding: "12px 14px", borderRadius: 12,
                       border: `1.5px solid ${T.borda}`, background: T.input,
                       color: T.texto, fontSize: 14, boxSizing: "border-box"
                   }} />
        </div>
    );
}